import React from 'react';

export function AdminPaymentModal({ show, selectedMember, amount, setAmount, notes, setNotes, onSubmit, onClose }) {
  if (!show || !selectedMember) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-2">Record Payment</h3>
        <p className="text-gray-600 mb-4">Recording payment for: <span className="font-bold">{selectedMember.member_name}</span></p>
        <p className="text-sm text-gray-500 mb-4">Current Balance: <span className={selectedMember.balance >= 0 ? 'text-green-600' : 'text-red-600'}>${selectedMember.balance.toFixed(2)}</span></p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Amount ($)</label>
            <input
              type="number"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              required
              data-testid="admin-payment-amount-input"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Notes (optional)</label>
            <input
              type="text"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              placeholder="e.g., Cash payment, check #123"
            />
          </div>
          <div className="flex space-x-4">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
              Record Payment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
